export var getCurrentMonth = function () {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var startDate = "".concat(year, "-").concat(month.toString().padStart(2, "0"), "-01");
    var lastDay = new Date(year, month, 0).getDate();
    var endDate = "".concat(year, "-").concat(month.toString().padStart(2, "0"), "-").concat(lastDay);
    return { startDate: startDate, endDate: endDate };
};
export var getPreviousMonth = function () {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    if (month === 0) {
        month = 12; // Diciembre
        year -= 1; // Año anterior
    }
    var startDate = "".concat(year, "-").concat(month.toString().padStart(2, "0"), "-01");
    var lastDay = new Date(year, month, 0).getDate();
    var endDate = "".concat(year, "-").concat(month.toString().padStart(2, "0"), "-").concat(lastDay);
    return { startDate: startDate, endDate: endDate };
};
export var getQuarterDates = function (quarterType) {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var startMonth = 1;
    var endMonth = 2;
    if (quarterType === "current") {
        if (month <= 3) {
            startMonth = 1; // Enero
            endMonth = 3; // Marzo
        }
        else if (month <= 6) {
            startMonth = 4; // Abril
            endMonth = 6; // Junio
        }
        else if (month <= 9) {
            startMonth = 7; // Julio
            endMonth = 9; // Septiembre
        }
        else {
            startMonth = 10; // Octubre
            endMonth = 12; // Diciembre
        }
    }
    else if (quarterType === "previous") {
        if (month <= 3) {
            startMonth = 10; // Octubre del año anterior
            endMonth = 12; // Diciembre del año anterior
            year -= 1;
        }
        else if (month <= 6) {
            startMonth = 1; // Enero
            endMonth = 3; // Marzo
        }
        else if (month <= 9) {
            startMonth = 4; // Abril
            endMonth = 6; // Junio
        }
        else {
            startMonth = 7; // Julio
            endMonth = 9; // Septiembre
        }
    }
    var startDate = "".concat(year, "-").concat(startMonth === null || startMonth === void 0 ? void 0 : startMonth.toString().padStart(2, "0"), "-01");
    var endDate = "".concat(year, "-").concat(endMonth === null || endMonth === void 0 ? void 0 : endMonth.toString().padStart(2, "0"), "-").concat(new Date(year, endMonth, 0).getDate());
    return { startDate: startDate, endDate: endDate };
};
export var getCurrentSemester = function () {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var startDate, endDate;
    if (month >= 1 && month <= 6) {
        startDate = "".concat(year, "-01-01");
        endDate = "".concat(year, "-06-30");
    }
    else {
        startDate = "".concat(year, "-07-01");
        endDate = "".concat(year, "-12-31");
    }
    return { startDate: startDate, endDate: endDate };
};
export var getCurrentDatePlusOneYear = function () {
    var now = new Date();
    var nextYear = new Date(now);
    nextYear.setFullYear(now.getFullYear() + 1);
    var formatDate = function (date) {
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var day = date.getDate().toString().padStart(2, "0");
        return "".concat(year, "-").concat(month, "-").concat(day);
    };
    var startDate = formatDate(now);
    var endDate = formatDate(nextYear);
    return { startDate: startDate, endDate: endDate };
};
